import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import "./PdfPage.css";
import NoData from "./NoData";
import ChartLoader from "./ChartLoader";
import CriticalTableLastPage from "./CriticalTableLastPage";

// export default function Critical(props) {
const Critical = forwardRef((props, ref1) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  //   const [refreshDate, setRefreshDate] = useState("");
  const [topThreeVin, setTopThreeVin] = useState([]);
  const [refs, setRefs] = useState({});
  const criticalLastPageRefs = useRef([]); // Array of refs for CriticalTableLastPage instances

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/critical_top_three_vin",
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter, props.selectTemp]);

  const appyData = (data) => {
    setTopThreeVin(data);
    criticalLastPageRefs.current = data.map(
      (_, i) => criticalLastPageRefs.current[i] || React.createRef()
    );
  };
  useImperativeHandle(ref1, () => ({
    getDataForSlide: () => ({
      topThreeVin,
      criticalTableLastPage: criticalLastPageRefs.current.map((ref) =>
        ref.current ? ref.current.getDataForSlide() : null
      ),
      // criticalTableLastPage: {
      //   ...ref1?.criticalLastPage?.getDataForSlide(),
      // },
    }),
  }));
  return (
    <div className="criticalpage">
      {topThreeVin.length > 0 &&
        topThreeVin.map((item, index) => (
          <CriticalTableLastPage
            gloablfilter={gloablfilter}
            topThreeVin={item}
            // ref={(ref) => (ref1.criticalLastPage = ref)}
            ref={criticalLastPageRefs.current[index]}
            criticalTableLastPageId={index}
          />
        ))}
    </div>
  );
});
export default Critical;
